
const digest = '6bb709fea0c63132c3bc6e496f53ba4add2a363df2e1f75e0974296c4731712f';
const classes = {"wrapper":"_wrapper_19jn5_1","header":"_header_19jn5_12","title":"_title_19jn5_16","content":"_content_19jn5_23"};
const css = `._wrapper_19jn5_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 4px;
}
._wrapper_19jn5_1:hover {
  background-color: rgb(217, 232, 254);
  cursor: pointer;
}
._wrapper_19jn5_1 ._header_19jn5_12 {
  display: flex;
  align-items: center;
}
._wrapper_19jn5_1 ._header_19jn5_12 ._title_19jn5_16 {
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  flex: 1;
}
._wrapper_19jn5_1 ._content_19jn5_23 {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  flex-wrap: wrap;
  color: #000000;
  font-weight: 400;
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  